import { render, staticRenderFns } from "./peorlist.vue?vue&type=template&id=4354f330&scoped=true"
import script from "./peorlist.vue?vue&type=script&lang=js"
export * from "./peorlist.vue?vue&type=script&lang=js"
import style0 from "./peorlist.vue?vue&type=style&index=0&id=4354f330&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../../../../../../../../../opt/build-cache/yunying/node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4354f330",
  null
  
)

export default component.exports